import React from 'react'
import { Link } from 'react-router-dom'
import useFetchContent from '../hooks/useFetchContent'
import Seo from '../components/Seo'

const PrivacyPolicy = () => {
  const { title, content, loading } = useFetchContent(
    'https://api-staging.sabraah.com/api/v1/users/privacy-policy',
    'Privacy Policy'
  )

  return (
    <>
      <Seo
        title="SabRaah Privacy Policy | Data & Privacy Protection"
        description="Read SabRaah's Privacy Policy to learn how we collect, use, protect, and manage your personal information when you use our travel platform."
        path="/privacy-policy"
      />

      <section className='commonBanner commonGredientBg '>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <h1>{title}</h1>
            </div>
          </div>
        </div>
      </section>

      <section className='commentTextPrivacy paddingCmn'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              {loading
                ? <p>Loading...</p>
                : <div dangerouslySetInnerHTML={{ __html: content }} />
              }
            </div>
          </div>
        </div>
      </section>

      <footer>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='footerLinks'>
                             <Link to="mailto:subscribe@sabraah.com">
                                contact us - subscribe@sabraah.com
                            </Link>
                            <div className='privacyLink'>
                                <Link to="/">Home</Link>
                                |
                                <Link to="/about-us">About Us</Link>
                                |
                                <Link to="/privacy-policy">Privacy Policy</Link>
                                |
                                <Link to="/terms-conditions">Terms & Conditions</Link>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default PrivacyPolicy
